import React, { useEffect, useState } from "react";
import API_BASE from "../api/apiBase";

export default function InvitePage() {
  const [loading, setLoading] = useState(true);
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);

  const token = window.location.pathname.split("/invite/")[1];

  useEffect(() => {
    async function fetchInvite() {
      try {
        const res = await fetch(`${API_BASE}/api/invite/${token}`);
        const data = await res.json();

        if (!data.success) {
          throw new Error("Invalid invite");
        }

        setInvite(data);
      } catch (err) {
        setError("Invite not found or expired.");
      } finally {
        setLoading(false);
      }
    }

    fetchInvite();
  }, [token]);

  if (loading) {
    return <div>Validating invite...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div style={{ maxWidth: "600px", margin: "50px auto", textAlign: "center" }}>
      <h2>Your contractor invited you to MeasureSmart</h2>

      <p>
        You were invited to create a project and share it with your contractor.
      </p>

      <p>
        Email: <strong>{invite.homeownerEmail}</strong>
      </p>

      <button

  onClick={() => {
  console.log("Saving invite token:", token);

  localStorage.setItem("inviteToken", token);

  console.log("Stored value:", localStorage.getItem("inviteToken"));

  window.location.href = "/signup";
}}
      >
        Create Your Project
      </button>
    </div>
  );
}
